import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Banner } from './types'

export const BANNERS_QUERY: TypedDocumentNode<
  { banners: Banner[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Banners($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    banners(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id url image image_low_res position observations created_at updated_at
    }
  }
`

export const BANNER_QUERY: TypedDocumentNode<{ banner: Banner | null }, { id: string }> = gql`
  query Banner($id: ID!) {
    banner(id: $id) {
      id client_id application_id url image image_low_res position observations created_at updated_at
    }
  }
`
